import React, { useState } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import { DialogMain, IconButtonMain } from "./styles/DialogStyles";
import CloseIcon from "@mui/icons-material/Close";
import jobs from "./data/job.json";
import MainButton from "../../shared/Button";
import JobsPopupTable from "./JobsPopupTable";
import PrintInvoices from "./PrintInvoices";

const SelectedJobsPopup = ({ open, handleClose }) => {
  const TableHeadData = [
    { title: "", val: "checkbox" },
    { title: "Sender", val: "Sender" },
    { title: "Receiver", val: "Receiver" },
    { title: "Order", val: "Order" },
    { title: "Assigned Driver", val: "AssignedDriver" },
    { title: "Status", val: "status" },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const OpenAndClosehandle = () => {
    setOpenDialog(true);
    handleClose();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <>
      <DialogMain open={open} onClose={handleClose} jobPopup={true}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6>Selected Jobs</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="selected_jobsContent">
          <JobsPopupTable
            TableHeadData={TableHeadData}
            BodyData={jobs}
            Hasaction={false}
          />
          <MainButton
            type="button"
            label="Generate and Send Invoices to Customers"
            MT="50"
            onClick={OpenAndClosehandle}
          />
        </DialogContent>
      </DialogMain>
      <PrintInvoices open={openDialog} handleClose={handleCloseDialog} />
    </>
  );
};

export default SelectedJobsPopup;
